export const API_URL = 'https://azure-rabbit-476548.hostingersite.com/public/api';

//export const API_URL = 'http://localhost:8000/api';

//export const Back_url = 'http://localhost:8000';

export const Back_url = 'https://azure-rabbit-476548.hostingersite.com/public';